"use strict";
/**
 * Attribute configuration for persona conditions
 * Defines hardcoded attributes available for employee filtering
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeConfig = void 0;
class AttributeConfig {
    /**
     * Get all hardcoded available attributes for UI dropdowns
     */
    static getAvailableAttributes() {
        return {
            employment: [
                // {
                //   path: "employmentStatus",
                //   displayName: "Employment Status",
                //   dataType: "string",
                //   category: "employment",
                // },
                {
                    path: "employments.jobTitle",
                    displayName: "Job Title",
                    dataType: "string",
                    category: "employment",
                    isArray: true,
                },
                {
                    path: "employments[0].jobTitle",
                    displayName: "Current Job Title",
                    dataType: "string",
                    category: "employment",
                },
                {
                    path: "employments.employmentType",
                    displayName: "Employment Type",
                    dataType: "string",
                    category: "employment",
                    isArray: true,
                },
                {
                    path: "employments[0].employmentType",
                    displayName: "Current Employment Type",
                    dataType: "string",
                    category: "employment",
                },
                {
                    path: "employeeNumber",
                    displayName: "Employee Number",
                    dataType: "string",
                    category: "employment",
                },
                {
                    path: "company",
                    displayName: "Company",
                    dataType: "string",
                    category: "employment",
                },
            ],
            location: [
                {
                    path: "homeLocation.city",
                    displayName: "Home City",
                    dataType: "string",
                    category: "location",
                },
                {
                    path: "homeLocation.state",
                    displayName: "Home State",
                    dataType: "string",
                    category: "location",
                },
                {
                    path: "homeLocation.country",
                    displayName: "Home Country",
                    dataType: "string",
                    category: "location",
                },
                {
                    path: "homeLocation.zipCode",
                    displayName: "Home Zip Code",
                    dataType: "string",
                    category: "location",
                },
                {
                    path: "homeLocation.name",
                    displayName: "Home Location Name",
                    dataType: "string",
                    category: "location",
                },
                {
                    path: "workLocation.name",
                    displayName: "Work Location Name",
                    dataType: "string",
                    category: "location",
                },
                {
                    path: "workLocation.city",
                    displayName: "Work City",
                    dataType: "string",
                    category: "location",
                },
                {
                    path: "workLocation.state",
                    displayName: "Work State",
                    dataType: "string",
                    category: "location",
                },
                {
                    path: "workLocation.country",
                    displayName: "Work Country",
                    dataType: "string",
                    category: "location",
                },
            ],
            // contact: [
            //   {
            //     path: "workEmail",
            //     displayName: "Work Email",
            //     dataType: "string",
            //     category: "contact",
            //   },
            //   {
            //     path: "personalEmail",
            //     displayName: "Personal Email",
            //     dataType: "string",
            //     category: "contact",
            //   },
            //   {
            //     path: "mobilePhoneNumber",
            //     displayName: "Mobile Phone",
            //     dataType: "string",
            //     category: "contact",
            //   },
            //   {
            //     path: "firstName",
            //     displayName: "First Name",
            //     dataType: "string",
            //     category: "contact",
            //   },
            //   {
            //     path: "lastName",
            //     displayName: "Last Name",
            //     dataType: "string",
            //     category: "contact",
            //   },
            //   {
            //     path: "preferredName",
            //     displayName: "Preferred Name",
            //     dataType: "string",
            //     category: "contact",
            //   },
            //   {
            //     path: "displayName",
            //     displayName: "Display Name",
            //     dataType: "string",
            //     category: "contact",
            //   },
            //   {
            //     path: "displayFullName",
            //     displayName: "Full Name",
            //     dataType: "string",
            //     category: "contact",
            //   },
            //   {
            //     path: "username",
            //     displayName: "Username",
            //     dataType: "string",
            //     category: "contact",
            //   },
            // ],
            groups: [
                {
                    path: "groups.name",
                    displayName: "Group Name",
                    dataType: "string",
                    category: "groups",
                    isArray: true,
                },
                {
                    path: "groups[0].name",
                    displayName: "Primary Group Name",
                    dataType: "string",
                    category: "groups",
                },
                {
                    path: "groups.type",
                    displayName: "Group Type",
                    dataType: "string",
                    category: "groups",
                    isArray: true,
                },
                {
                    path: "groups[0].type",
                    displayName: "Primary Group Type",
                    dataType: "string",
                    category: "groups",
                },
                {
                    path: "groups.id",
                    displayName: "Group ID",
                    dataType: "string",
                    category: "groups",
                    isArray: true,
                },
            ],
            //custom attributes should not be shown unless they are in the employees
            custom: [
                {
                    path: "customMappings.national_insurance_no",
                    displayName: "National Insurance Number",
                    dataType: "string",
                    category: "custom",
                },
            ],
        };
    }
    /**
     * Find an attribute definition by path
     */
    static findAttributeByPath(path) {
        const allAttributes = this.getAvailableAttributes();
        for (const categoryAttribs of Object.values(allAttributes)) {
            const found = categoryAttribs.find((attr) => attr.path === path);
            if (found)
                return found;
        }
        return undefined;
    }
}
exports.AttributeConfig = AttributeConfig;
